import React, { useRef, useState } from "react";
import LinkSlider from "../Components/LinkSlider";
import MissionSection from "../Components/MissionSection";
import TestimonialSection from "../Components/TestimonialSection";
import { SubscribeSection } from "../Components/SubscribeSection";
import { motion } from "framer-motion";
import { RoutesPaths } from "../Router/Constant";
import { useNavigate } from "react-router-dom";
import PeopleSafetyExecution from "../Components/PeopleSafetyExecution";
import EsgSection from "../Components/EsgSection";
import { useLanguage } from "../Router/LanguageContext";

export default function Landing() {
  const videoRef = useRef(null);
  const [isPaused, setIsPaused] = useState(true);
  const navigate = useNavigate();
  const [videoLoaded, setVideoLoaded] = useState(false);
  const { dictionary } = useLanguage();

  const handlePlay = () => {
    videoRef.current.play();
    setIsPaused(false);
  };

  const energyArray = {
    title: dictionary?.renewableTitle,
    description: dictionary?.renewableDesc,
    arrayData: dictionary?.renewablePoints || [],
    img1: "/assets/img/Renewablenergy.jpg",
    routerPath: "/renewable-energy",
  };

  const oilArray = {
    title: dictionary?.oilGasTitle,
    description: dictionary?.oilGasDesc,
    arrayData: dictionary?.oilGasPoints || [],
    img1: "/assets/img/oilAndGas.jpg",
    routerPath: "/oil-gas",
  };

  const epcArray = {
    title: dictionary?.epcInfraTitle,
    description: dictionary?.epcInfraDesc,
    arrayData: dictionary?.epcInfraPoints || [],
    img1: "/assets/img/epcimg.jpg",
    routerPath: "/epc-Infrastructure",
  };

  const energySector = {
    title: dictionary?.energySectorTitle,
    description: dictionary?.energySectorDesc,
    arrayData: dictionary?.energySectorPoints || [],
    tag: dictionary?.energySectorTag,
    img1: "/assets/img/evolvingimg.png",
    img2: "/assets/img/energySectorEffectEffect.png",
  };

  const redirectAbout = () => {
    navigate(RoutesPaths.ABOUTUS);
  };
  const redirectContactUs = () => {
    navigate(RoutesPaths.CONTACTUS);
  };

  // const potentialCards = [
  //   {
  //     color: "#0076cb",
  //     icon: "/assets/img/Renewableenergy.jpg",
  //     title: "Renewable energy production",
  //     desc: "We transform resilient cactus biomass into renewable biogas energy, delivering reliable and continuous power generation designed to operate efficiently in dry desert environments.",
  //   },
  //   {
  //     color: "#006440",
  //     icon: "/assets/img/PricklyPear.png",
  //     title: "Sustainable desert agriculture",
  //     desc: "Our cactus cultivation system uses minimal water and grows naturally in arid climates, supporting sustainable land use and long-term agricultural productivity.",
  //   },
  //   {
  //     color: "#00caff",
  //     icon: "/assets/img/Localeconomic.jpg",
  //     title: "Local economic development",
  //     desc: "The project promotes regional development by creating jobs, supporting local infrastructure, and generating new economic opportunities for surrounding communities.",
  //   },
  //   {
  //     color: "#00ce80",
  //     icon: "/assets/img/energyecosystem.jpg",
  //     title: "Scalable energy ecosystem",
  //     desc: "Starting with 400 hectares and expanding to more than 5,000 hectares, the project is designed to deliver large-scale environmental and economic benefits.",
  //   },
  // ];

  return (
    <>
      <div className="heroSectionBgVideoWrapper">
        {!videoLoaded && (
          <img src="/assets/img/heroBanner.png" alt="" className="bgVideo" />
        )}
        <video
          className={`bgVideo ${videoLoaded ? "showVideo" : "hideVideo"}`}
          autoPlay
          muted
          loop
          playsInline
          onLoadedData={() => setVideoLoaded(true)}
        >
          <source src="/assets/video/LandingVideo.mp4" type="video/mp4" />
        </video>

        <div className="heroSectionContentOuter heroSectionContentOuternoshade">
          <div className="container-fluid maxContainerSection">
            <div className="row heroSectionContent">
              <div className="col-md-10 heroLeftSection">
                <h2 className="m-0 f-s-48">{dictionary?.herotitle}</h2>
                {/* <p className="m-0 f-s-20">
                  Delivering end-to-end engineering, procurement, and project
                  execution services for Oil & Gas operations, Renewable Energy
                  developments, Mining facilities, and industrial
                  infrastructure.
                </p> */}
              </div>

              <div className="col-md-2 heroDownArrow">
                <img
                  src="/assets/img/heroDownArrow.svg"
                  alt=""
                  onClick={redirectContactUs}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <LinkSlider />

      <div className="container-fluid maxContainerSection commonPadding">
        <div className="row">
          <div className="col-md-6">
            <div className="energySectorImage">
              <motion.img
                src={energySector?.img1}
                className="img-fluid"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              />
              <motion.img
                src={energySector?.img2}
                className="img-fluid energySectorEffect"
                initial={{ opacity: 0, scale: 0.85 }}
                whileInView={{ opacity: 1, scale: 1 }}
                whileHover={{
                  scale: 1.03,
                  transition: { duration: 0.25, ease: "easeIn" },
                }}
                transition={{ duration: 1, ease: "easeInOut" }}
                viewport={{ once: true }}
              />
            </div>
          </div>
          <div className="col-md-6 energysection">
            <motion.h2
              className="mission-title m-0 f-s-48"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              {energySector.title}
            </motion.h2>
            <motion.p
              className="mission-text m-0 f-s-18"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              {energySector?.description}
            </motion.p>
            <ul className="mission-list">
              {energySector?.arrayData?.map((item, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                  viewport={{ once: true }}
                >
                  <div className="energysectionpoints f-s-18">
                    <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                  </div>
                </motion.li>
              ))}
            </ul>

            <div className="energysectioncomment">
              <p className="m-0">{energySector?.tag}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="whoweareoutersection">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12 whowearehedaersection">
              <h2 className="m-0 f-s-48">{dictionary?.whoWeAreTitle}</h2>
              <p className="m-0 f-s-20">{dictionary?.whoWeAreDesc}</p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="whowearesection">
                <div className="whoweareheadershade"></div>
                <div className="whowearesectionInner">
                  <img
                    src="/assets/img/OurMission.svg"
                    alt=""
                    className="missionDefault"
                  />
                  <img
                    src="/assets/img/OurMissionActive.svg"
                    alt=""
                    className="missionActive"
                  />

                  <h3 className="m-0">{dictionary?.missionTitle}</h3>
                  <p className="m-0">{dictionary?.missionDescMain}</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="whowearesection">
                <div className="whoweareheadershade"></div>
                <div className="whowearesectionInner">
                  <img
                    src="/assets/img/OurVision.svg"
                    alt=""
                    className="missionDefault"
                  />
                  <img
                    src="/assets/img/OurVisionActive.svg"
                    alt=""
                    className="missionActive"
                  />
                  <h3 className="m-0">{dictionary?.visionTitleMain}</h3>
                  <p className="m-0">{dictionary?.valuesDescMain}</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="whowearesection">
                <div className="whoweareheadershade"></div>
                <div className="whowearesectionInner">
                  <img
                    src="/assets/img/OurValue.svg"
                    alt=""
                    className="missionDefault"
                  />
                  <img
                    src="/assets/img/OurValueActive.svg"
                    alt=""
                    className="missionActive"
                  />
                  <h3 className="m-0">{dictionary?.valuesTitleMain}</h3>
                  <p className="m-0">{dictionary?.valuesDescMain}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="row readyServices">
            <div className="col-md-10 readyServicesLeftSec">
              <img src="/assets/img/zap-fast.svg" alt="" />
              <p className="m-0 f-s-32">{dictionary?.readyServiceText}</p>
            </div>
            <div className="col-md-2">
              <button className="radius-btn" onClick={redirectAbout}>
                <span className="btn-text">{dictionary?.discoverMore}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="section section-who-we-are p-0">
        <div className="container-fluid maxContainerSection commonPadding pb-0">
          <div className="row">
            <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
              <h2 className="m-0 f-s-48">{dictionary?.solutionsTitle}</h2>
              <p className="m-0 f-s-20 ">{dictionary?.solutionsDesc}</p>
            </div>
          </div>
          <MissionSection data={energyArray} />
          <MissionSection reverse data={oilArray} />
          <MissionSection data={epcArray} />
        </div>
      </div>

      {/* <div className="integratedCleanSection">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
              <h2 className="m-0 f-s-48">Denira</h2>
              <h4 className="m-0 f-s-32">
                Turning desert potential into sustainable energy
              </h4>
              <p className="m-0 f-s-20">
                Denira is transforming the Namibe desert into a sustainable
                energy ecosystem. By cultivating resilient cactus crops and
                converting biomass into biogas, we generate continuous renewable
                energy while creating economic opportunities, supporting local
                communities, and restoring environmental balance.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="shadowBoxPotentialMain">
                {potentialCards.map((card, index) => (
                  <div className="shadowBoxPotentialCardOuter" key={index}>
                    <div
                      className="shadowBoxPotential upperShadowBox"
                      style={{ backgroundColor: card.color }}
                    ></div>

                    <div className="desertPotential">
                      <motion.div
                        className="PotentialIcon"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                      >
                        <img
                          src={card.icon}
                          alt={card.title}
                          className="img-fluid"
                        />
                      </motion.div>
                      <motion.h3
                        className="mission-title m-0 f-s-28"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                      >
                        {card.title}
                      </motion.h3>
                      <motion.p
                        className="mission-text m-0 f-s-18"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        viewport={{ once: true }}
                      >
                        {card.desc}
                      </motion.p>
                    </div>

                    <div
                      className="shadowBoxPotential bottomShadowBox"
                      style={{ backgroundColor: card.color }}
                    ></div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-12">
              <div className="exploreDenira">
                <Link to={RoutesPaths.DENIRA} className="radius-btn">
                  <span className="btn-text">Explore the denira</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="container-fluid maxContainerSection commonPadding">
        <div className="row">
          <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
            <h2 className="m-0 f-s-48">{dictionary?.howWeWorkTitle}</h2>
            <p className="m-0 f-s-20 ">
               {dictionary?.howWeWorkDesc}
            </p>
          </div>
        </div>

        <div className="row video-wrapperSection">
          <div className="col-md-12">
            <div className="hww-video-wrapper2">
              <div className="hww-video-wrapper">
                <video
                  ref={videoRef}
                  className="hww-video-player"
                  src="/assets/video/constriuction.mp4"
                  controls
                  autoPlay={false}
                  onPlay={() => setIsPaused(false)}
                  onPause={() => setIsPaused(true)}
                />
                {isPaused && (
                  <button className="hww-play-btn" onClick={handlePlay}>
                    <img src="/assets/img/play.svg" alt=" " />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <PeopleSafetyExecution />
      <TestimonialSection />
      <EsgSection />
      <SubscribeSection />
    </>
  );
}
